import { handledCurrencyFields } from '~/utils/localization';

const store = {
    namespaced: true,
    state() {
        return {
            globalSettings: {
                additional_settings: {
                    header_style: 'fixed',
                },
                mainUiInterface: {
                    mobileBarUiType: 'mobileBar_default', //[mobileBar_default, mobileBar_custom]
                    // mobileHeaderUiType: 'mobileHeader_default', //[mobileBar_default, mobileBar_custom]
                    articleUiType: 'article_default', // [article_default, article_custom ]
                    bannersUiType: 'banners_default', // [banners_default, banners_default ]
                    mainNavigationType: 'main_nav_default', // [main_nav_default, main_nav_custom]
                    mainSliderType: 'main_slider_default', // [main_slider_default, main_slider_custom]
                    mainProductSliderType: 'main_product_slider_default', //[main_product_slider_default, main_product_slider_custom]
                    topNavigationType: 'top_nav_default', // [top_nav_default, top_nav_custom]
                    vacancyUiType: 'vacancy-default', // [vacancy-default, vacancy-custom]
                    contactsUiType: 'contacts-default', // [ contacts-default,  contacts-custom]
                    reviewsUiType: 'reviews-default',
                    mainTheme: 'light_theme',
                    videoType: 'video_default',
                    mainLang: 'ru',
                },
                siteLogo: 'https://admin.ecom.md/media/site_settings/logo/jbl-logo-t.png',
                colors: {},
                images: {
                    image404: '',
                    imageCompareError: '',
                    imageFavoriteNotFound: '',
                    imageSearchNotFound: '',
                    imageEmptyCart: '',
                    imageProductFiltersNotFound: '',
                },
                phones: {
                    mainPhoneNumber: '+373 79 596 888',
                    stationaryPhoneNumber: '+373 77 777 777',
                    supportPhoneNumber: '+373 79 596 111',
                    serviceCenterPhoneNumber: '+373 79 596 000',
                },
                socialNetworkLinks: {
                    linkViber: 'qwer',
                    linkInstagram: 'qwer',
                    linkFacebook: 'qwer',
                    linkTiktok: 'qwer',
                },
                mapIcons: {
                    storeIconDisabled: '',
                    storeIconActive: '',
                    serviceIconActive: '',
                },
            },
            globalPopupIsShowed: false,
            theme: 'light-theme',
            mainPhoneNumber: '+373 79 596 888',
            isJbl: false,
            isHabsev: false,
            isVitrina: false,
            isFarmacie: false,
            isNovaPorta: false,
            isEcaterix: false,
            isCasaDelTabaco: false,
            isUniPlast: false,
            isItalTech: false,
            isMasterDoors: false,
            isNewKids: false,

            // Settings
            isUnitsMeasuresAllow: false,
            isModalOrderCheckout: false,
            modals: [],
            opened: [],
            paymentSystems: [],
        };
    },
    getters: {
        getMainTheme: state => state.globalSettings.mainUiInterface.mainTheme,
        getCurrentTheme: state => state.theme,
        getGlobalColors: state => state.globalSettings.colors,
        getMainlang: state => state.globalSettings.mainUiInterface?.mainLang,
        globalSettings: state => state.globalSettings,
        mainPhoneNumber: state => state.mainPhoneNumber,
        stationaryPhoneNumber: state => state?.globalSettings?.phones?.stationaryPhoneNumber,
        getMainEmail: state => state.globalSettings?.main_email,
        isVitrina: state => state.isVitrina,
        getLogos: state => state.globalSettings.logo,
        getIcons: state => state.globalSettings.icons,
        creditsAvailable: state => state.globalSettings?.credits,
        getIsJbl: state => state.isJbl,
        getIsHabsev: state => state.isHabsev,
        getIsFarmacie: state => state.isFarmacie,
        getIsNovaPorta: state => state.isNovaPorta,
        getIsNewKids: state => state.isNewKids,
        getIsCasaDelTabaco: state => state.isCasaDelTabaco,
        getIsUniPlast: state => state.isUniPlast,
        getIsItalTech: state => state.isItalTech,
        getDeliveryPrice: state => state.globalSettings?.delivery_price,
        getHeaderStyle: state => state.globalSettings.additional_settings.header_style,
        getDeliveryText: state => state.globalSettings?.text_delivery_info,
        getIsEcaterix: state => state.isEcaterix,
        getPopup: state => state.globalSettings?.popups,
        getGlobalPopupIsShowed: state => state.globalPopupIsShowed,
        isUnitsMeasuresAllow: state => state.isUnitsMeasuresAllow,
        getIsMasterDoors: state => state.isMasterDoors,
        getActiveProductCount: state => state.globalSettings?.active_products_count,
        getDefaultSortByPriority: state => state.globalSettings?.additional_settings?.sort_by_priority,
        getDefaultSorting: state => state.globalSettings?.default_sorting,
        getFiltersAndSortingView: state => state.globalSettings?.mainUiInterface?.filter_sort_catalog_view_type,
        getShareKeys: state => state.globalSettings?.additional_settings?.shared_keys,
        getEnableProductReviews: state => state.globalSettings?.additional_settings?.enable_product_reviews,
        getHasProductOfTheDay: state => state.globalSettings?.has_product_of_the_day,
        getComparePageViewType: state => state.globalSettings?.mainUiInterface?.compare_page_view_type,
        getIsAllowNegativeStock: state => state.globalSettings?.allow_negative_stock,
        getFilteredSocialMediaLinksForFooter: state => {
            return (
                state.globalSettings?.social_media?.filter(
                    social => social.key.slug.toLowerCase() !== 'viber' && social.key.slug.toLowerCase() !== 'telegram'
                ) || []
            );
        },
        getSideBarView: state => state.globalSettings?.mainUiInterface?.sidebar_view,
        getMainPageBrandsView: state => state.globalSettings?.mainUiInterface?.main_page_brand_view,
        opened: state => state.opened,
        isModalOrderCheckout: state => state.isModalOrderCheckout,
        getModals: state => {
            return state.globalSettings?.popups_configuration;
        },
        getModalByKey: state => key => {
            return state.globalSettings?.popups_configuration.find(modal => modal.key.key === key);
        },
        getPaymentSystems: state => state.paymentSystems || [],
        getMainPageInfoBlock: state => state.globalSettings?.main_page_info_block,
        getNoScriptCode: state => state.globalSettings?.styles?.no_script_text,
        getCalendarSettings: state => state.globalSettings?.calendar_settings,
        getIsRegistrationRequiredForOrder: state => state.globalSettings?.is_registration_required_for_order,
        getHasTaxCalculation: state => state.globalSettings?.has_tax_calculation,
        getPromotionsOnMainPage: state => state.globalSettings?.mainUiInterface?.promotions_main_page_view_type === 'view_1',
        getBlackAndWhiteProductCardForPreOrder: state =>
            state.globalSettings?.additional_settings?.black_and_white_product_card_for_pre_order,
        getShowStockInTheProductCart: state => state.globalSettings?.additional_settings?.show_stock_quantity_in_the_product_card,
        getProductDisplay: state => state.globalSettings?.product_display,
        getCounterInTheProductCart: state => state.globalSettings?.mainUiInterface?.counter_in_the_product_card,
        getMobileAppSettings: state => state.globalSettings?.mobile_apps_settings,
        getDiscountCardSettings: state => state.globalSettings?.discount_card_settings,
    },
    mutations: {
        SET_GLOBAL_SETTINGS: (state, data) => (state.globalSettings = data),
        SET_CART_SETTINGS: (state, data) => (state.globalSettings.cart_settings = data),
        SET_THEME: (state, theme) => (state.theme = theme),
        SET_MAIN_PHONE_NUMBER: (state, data) => (state.mainPhoneNumber = data),
        SET_IS_JBL: (state, flag) => (state.isJbl = flag),
        SET_IS_VITRINA: (state, flag) => (state.isVitrina = flag),
        SET_IS_FARMACIE: (state, flag) => (state.isFarmacie = flag),
        SET_IS_NOVA_PORTA: (state, flag) => (state.isNovaPorta = flag),
        SET_IS_NEW_KIDS: (state, flag) => (state.isNewKids = flag),
        SET_IS_CASA_DEL_TABACO: (state, flag) => (state.isCasaDelTabaco = flag),
        SET_IS_UNI_PLAST: (state, flag) => (state.isUniPlast = flag),
        SET_IS_ITAL_TECH: (state, flag) => (state.isItalTech = flag),
        SET_IS_HABSEV: (state, flag) => (state.isHabsev = flag),
        SET_IS_ECATERIX: (state, flag) => (state.isEcaterix = flag),
        SET_GLOBAL_POPUP_IS_SHOWED: (state, flag) => (state.globalPopupIsShowed = flag),
        SET_IS_UNITS_MEASURES_ALLOW: (state, flag) => (state.isUnitsMeasuresAllow = flag),
        SET_IS_MASTER_DOORS: (state, flag) => (state.isMasterDoors = flag),
        OPEN: (state, name) => state.opened.push(name),
        CLOSE: state => state.opened.splice(0),
        SET_IS_MODAL_CHECKOUT: (state, flag) => (state.isModalOrderCheckout = flag),
        SET_MODALS: (state, data) => (state.modals = data),
        SET_PAYMENT_SYSTEMS: (state, data) => (state.paymentSystems = data),
        SET_PRODUCT_DISPLAY: (state, data) => (state.globalSettings.product_display = data),
    },
    actions: {
        async initializeFarmacieToken({ commit }) {
            const theme = process.env?.THEME;
            const isFarmacie = theme === 'FARMACIE';
            commit('SET_IS_FARMACIE', isFarmacie);
        },
        async initializeNovaPortaToken({ commit }) {
            const theme = process.env.THEME;
            const isNovaPorta = theme === 'NOVAPORTA';
            commit('SET_IS_NOVA_PORTA', isNovaPorta);
        },
        async initializeNewKidsToken({ commit }) {
            const token = process.env.TOKEN;
            const isNewKids = token === 'azx8tru!WUZ8jzk-hax';
            commit('SET_IS_NEW_KIDS', isNewKids);
        },
        async initializeCasaDelTabacoToken({ commit }) {
            const token = process.env.TOKEN;
            const isCasaDelTabaco = token === 'etj7UPB7agy*mhv5qwe';
            commit('SET_IS_CASA_DEL_TABACO', isCasaDelTabaco);
        },
        async initializeUniPlastToken({ commit }) {
            const token = process.env.TOKEN;
            const isUniPlast = token === 'efr8dat7cwe3GDG-uec';
            commit('SET_IS_UNI_PLAST', isUniPlast);
        },
        async initializeItalTechToken({ commit }) {
            const token = process.env.TOKEN;
            const isItalTech = token === 'ubv0qxa-BGB9mtx.utx';
            commit('SET_IS_ITAL_TECH', isItalTech);
        },
        async initializeHabsevToken({ commit }) {
            const token = process.env.TOKEN;
            const isHabsev = token === 'gmr0nwt*yur3tnu_CKG';
            commit('SET_IS_HABSEV', isHabsev);
        },
        async initializeJblToken({ commit }) {
            const token = process.env.TOKEN;
            const isJbl = token === 'keu7jte6dyf@uzb.RBK';
            commit('SET_IS_JBL', isJbl);
        },
        async initializeEcaterixToken({ commit }) {
            const token = process.env.TOKEN;
            const isEcaterix = token === 'qxj1qmw2hpx1NBP@//!44212mxj';
            commit('SET_IS_ECATERIX', isEcaterix);
        },
        async initializeMasterDoorsToken({ commit }) {
            const token = process.env.TOKEN;
            const isMasterDoors = token === 'qmr7vqg2grg5trh!JBC';
            commit('SET_IS_MASTER_DOORS', isMasterDoors);
        },
        setTheme: ({ commit }, theme) => commit('SET_THEME', theme),
        setGlobalSettings: ({ commit }, data) => commit('SET_GLOBAL_SETTINGS', data),
        setMainPhoneNumber: ({ commit }, data) => commit('SET_MAIN_PHONE_NUMBER', data),
        setIsVitrina: ({ commit }, flag) => commit('SET_IS_VITRINA', flag),
        setIsUnitsMeasuresAllow: ({ commit }, flag) => commit('SET_IS_UNITS_MEASURES_ALLOW', flag),
        setCurrencyLocalization: async function ({ commit }, currency) {
            const currentLocale = await this.$i18n.locale;

            const currentLangField = await this.$i18n.getLocaleMessage(currentLocale);
            const updateLangFields = await handledCurrencyFields(currentLangField, currency, currentLocale);

            await this.$i18n.setLocaleMessage(currentLocale, updateLangFields);
        },
        fetchGlobalSettings: async function ({ commit }) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/settings/global_site_settings`,
                });

                const theCurrency = res.data.project_currency;
                await this.dispatch('global/setCurrencyLocalization', theCurrency);

                if (!res.data.product_display) {
                    res.data.product_display = 'grid';
                }

                // if (!res.data.filter_display) {
                //     res.data.filter_display = 'ViewType1';
                // }

                if (!res.data.pagination_option) {
                    res.data.pagination_option = 'pagination';
                }

                this.$pocketSettings = { myCustomContent: 'CUSTOM DATA' };

                commit('SET_IS_UNITS_MEASURES_ALLOW', res.data.additional_settings?.is_units_measurement || false);

                commit('SET_GLOBAL_SETTINGS', res.data);
                commit('SET_MAIN_PHONE_NUMBER', res.data.phones.mainPhoneNumber);
            } catch (error) {
                console.dir(error);
            }
        },
        open: ({ commit }, name) => {
            commit('CLOSE');
            commit('OPEN', name);
        },
        close: ({ commit }) => commit('CLOSE'),
        setIsModalCheckout: async function ({ commit }, flag) {
            commit('SET_IS_MODAL_CHECKOUT', flag);
        },
        setModals: async function ({ commit }, data) {
            commit('SET_MODALS', data);
        },
        fetchPaymentSystems: async function ({ commit }) {
            try {
                const response = await this.$axios.$get('base/payment-systems');

                if (response?.length) {
                    commit('SET_PAYMENT_SYSTEMS', response);
                }
            } catch (e) {
                console.error(e);
            }
        },
    },
};

export default store;
